import { TFunction } from 'i18next'

import { REGION_CODES } from 'const/codes'

export const getRegionNames = (t: TFunction): any => ({
    [REGION_CODES.EU]: t('common:regions.europe.name', 'Europe'),
    [REGION_CODES.JP]: t('common:regions.asiaPacific.abbreviation', 'APAC'),
    [REGION_CODES.NA]: t('common:regions.northAmerica.name', 'North America'),
})
